/* Fixed-order categorical palette. Colors are assigned per-label (first-seen),
   not per-rank — so the same event/reason always renders the same color across
   the Donations and Expenses charts, regardless of where it ranks in each. */
export const CHART_COLORS = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300'];

const chartColorMap = {};
let chartColorNext = 0;

export function colorForLabel(label) {
  if (!chartColorMap[label]) {
    chartColorMap[label] = CHART_COLORS[chartColorNext % CHART_COLORS.length];
    chartColorNext++;
  }
  return chartColorMap[label];
}

export function toChartEntries(map) {
  const arr = Object.entries(map).filter(([, v]) => v > 0).sort((a, b) => b[1] - a[1]);
  const top = arr.slice(0, 6);
  const rest = arr.slice(6);
  const entries = top.map(([label, value]) => ({ label, value, color: colorForLabel(label) }));
  if (rest.length) {
    entries.push({ label: 'Other', value: rest.reduce((s, [, v]) => s + v, 0), color: '#c3c2b7' });
  }
  return entries;
}
